import manifestData from '@/content/docs/manifest.json';

export interface DocsPageEntry {
  slug: string;
  path: string;
  title: string;
  relPath: string;
  order: number;
}

export interface DocsRole {
  slug: string;
  label: string;
  pages: DocsPageEntry[];
}

export interface DocsManifest {
  version: string;
  generatedAt: string;
  roles: DocsRole[];
}

export const manifest: DocsManifest = manifestData as DocsManifest;

export function findRole(slug: string | undefined): DocsRole | undefined {
  if (!slug) return undefined;
  return manifest.roles.find((r) => r.slug === slug);
}

export function findPage(roleSlug: string | undefined, pageSlug: string | undefined): DocsPageEntry | undefined {
  const role = findRole(roleSlug);
  if (!role) return undefined;
  return role.pages.find((p) => p.slug === pageSlug);
}
